/**
 * Shared Slack OAuth popup → opener delivery (BroadcastChannel, localStorage, postMessage).
 * Keep in sync with oauth-popup Stimulus controller consumers.
 */
export const SLACK_OAUTH_STORAGE_PREFIX = "chk:slack_oauth:"

/**
 * @param {object} payload — { type, flowToken, success, oauthData? }
 * @param {{ channelName?: string }} [options]
 */
export function notifySlackOAuthParent(payload, { channelName = "slack_oauth" } = {}) {
  try {
    const channel = new BroadcastChannel(channelName)
    channel.postMessage(payload)
    channel.close()
  } catch {
    /* unsupported or blocked */
  }

  if (payload.flowToken != null && payload.flowToken !== "") {
    try {
      localStorage.setItem(SLACK_OAUTH_STORAGE_PREFIX + String(payload.flowToken), JSON.stringify(payload))
    } catch {
      /* quota / private mode */
    }
  }

  if (window.opener && !window.opener.closed) {
    try {
      window.opener.postMessage(payload, window.location.origin)
    } catch {
      /* opener policy */
    }
  }
}
